import { TAG } from "../constants";
import {
  CreateMassageArgs,
  MessagingThread,
  MessageThreadWithLastMessage,
  MessageType,
} from "../types";
import { patientApi } from "./patientApi";

export const messagesApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getMessageThreads: builder.query<MessagingThread[], void>({
      query: () => ({
        url: "/api/patient/message-threads",
        method: "GET",
      }),
      providesTags: [TAG.MESSAGE_THREADS, TAG.USER],
    }),

    getMessages: builder.query<MessageType[], string>({
      query: (threadId) => ({
        url: `/api/patient/messages/${threadId}`,
        method: "GET",
      }),
      providesTags: (_returns, _error, threadId) => [
        { type: TAG.MESSAGES, id: threadId },
      ],
    }),

    createMessage: builder.mutation<MessageType, CreateMassageArgs>({
      query: (body) => ({
        url: "/api/patient/messages",
        method: "POST",
        body,
      }),

      invalidatesTags: [TAG.MESSAGES, TAG.TASKS, TAG.MESSAGE_THREADS],
    }),
    getMessageThreadByProductId: builder.query<
      MessageThreadWithLastMessage,
      number
    >({
      query: (productId) => ({
        method: "GET",
        url: `/api/patient/message-threads/product/${productId}`,
      }),
      providesTags: [TAG.MESSAGE_THREADS],
    }),
    getMessageThreadByProductSlug: builder.query<MessagingThread, string>({
      query: (productSlug) => ({
        method: "GET",
        url: `/api/patient/message-threads/${productSlug}`,
      }),
      providesTags: [TAG.MESSAGE_THREADS],
    }),
  }),
});

export const {
  useGetMessageThreadsQuery,
  useGetMessagesQuery,
  useCreateMessageMutation,
  useGetMessageThreadByProductIdQuery,
  useGetMessageThreadByProductSlugQuery,
} = messagesApi;
